<template>
  <div id="contenedor-actualizar-datos-usuario">
    <v-form
    v-model="formularioValido"
    ref="actualizarDatosUsuario">
      <v-card>
        <v-card-title class="secondary--text">
          Actualizar Datos de Usuario
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            cols="12"
            v-model="funcionario.nombre"
            label="Nombre">
          </custom-text-field>
          <custom-text-field
            cols="12"
            v-model="funcionario.puesto"
            label="Puesto">
          </custom-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoFuncionarios from '@/components/administracion/configuracion/catalogos/funcionarios/mixCatalogoFuncionarios';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ActualizarDatosUsuario',
  mixins: [mixCatalogoFuncionarios],
  props: {
    funcionarioId: {
      type: String,
      required: false,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
      formularioValido: false,
      funcionario: {
        nombre: this.$auth.user.nombre,
        puesto: this.$auth.user.puesto,
      },
    };
  },
  methods: {
    async guardar() {
      this.$auth.user.nombre = this.funcionario.nombre;
      this.$auth.user.puesto = this.funcionario.puesto;
      await this.mixActualizarDatosFuncionario();
    },
    limpiarFormulario() {
      this.$refs.actualizarDatosUsuario.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },

};
</script>

<style>

</style>
